import React, { useEffect, useRef } from "react";
import { Container } from "./styled";
const Modal = ({
  isOpen,
  toggleModal,
  closeOnOutsideClick,
  posx,
  posy,
  deletePos,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        closeOnOutsideClick &&
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        toggleModal();
      }
    };
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef, closeOnOutsideClick, posx, posy]);
  return (
    <Container
      className={isOpen === true ? "active" : null}
      style={{ left: `${posx}px`, top: `${posy}px` }}
    >
      <div
        className="option_wrapper flex_center_space-between"
        ref={modalRef}
        onClick={(e) => deletePos()}
      >
        <img
          src="/assets/delete-icon.svg"
          className="trash-can-button"
          alt=""
        />
        <p>Eliminar</p>
      </div>
    </Container>
  );
};
export default Modal;
